import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, ParamMap, Router } from '@angular/router';
import { CoreService, DataService, DialogResult, DialogService, FormConfigurationService, SaveDataRequest, SaveFormEvent, SpinnerService } from 'dspx-core';
import { API_ENDPOINTS, API_ENDPOINT_KEYS } from '../../constants/api-endpoints.constants';
import { OVERVIEW_CARDSET_LAYOUT_FIELD_TYPE_REPLACEMENTS, POP_UP_CODES, REFERENCE_DATA_IDS, SAVE_RESULT_STATUS } from '../../constants/app-data.constants';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';
import { TEMPLATES, VERSIONS } from '../../constants/templates.constants';
import { AppDataService } from '../../services/app-data.service';
import { ErrorService } from '../../services/error.service';
import { BaseCardSetDetailComponent } from '../base-card-set-detail-component/base-card-set-detail.component';
import { finalize, take } from 'rxjs';
import { ApplicationUserAssignRequest } from 'src/app/models/application-user-assign-request';
import { ApplicationUserAssignRequestPopupQuestion } from 'src/app/interfaces/application-user-assign-request-popup-question.interface';
import { ApplicationDetailCreateUpdateCarerResponse } from 'src/app/interfaces/application-detail-create-update-carer-response.interface';
import { ApplicationRejectPopupQuestion } from 'src/app/interfaces/application-reject-popup-question.interface';
import { ApplicationRejectRequest } from 'src/app/models/application-reject-request';

@Component({
  selector: 'app-application-detail-create-update-carer',
  templateUrl: './application-detail-create-update-carer.component.html',
  styleUrl: './application-detail-create-update-carer.component.scss'
})
export class ApplicationDetailCreateUpdateCarerComponent extends BaseCardSetDetailComponent implements OnInit, OnDestroy, AfterViewInit {
  fieldTypeReplacements = OVERVIEW_CARDSET_LAYOUT_FIELD_TYPE_REPLACEMENTS;
  formServiceEndpoint: string = API_ENDPOINT_KEYS.getApplicationDetailCreateUpdateCarerConfigAndResponse;

  templateId: number = TEMPLATES.applicationDetailCreateUpdateCarer;
  versionNo: number = VERSIONS.latest;
  model: any;
  activeDialog: string = '';
  id: string = '';
  response: ApplicationDetailCreateUpdateCarerResponse;

  constructor(protected router: Router,
    protected route: ActivatedRoute,
    protected appDataService: AppDataService,
    protected dialogService: DialogService,
    private coreService: CoreService,
    private spinnerService: SpinnerService,
    private dataService: DataService,
    private errorService: ErrorService,
    private formConfigurationService: FormConfigurationService,
  ) {
    super(router, appDataService, dialogService);
  }

  ngOnInit(): void {
    this.coreService.applicationFunctions = {
      home: () => this.home(),
      assign: () => this.assign(),
      accept: () => this.accept(),
      reject: () => this.reject(),
      matchToExistingContact: () => this.matchToExistingContact(),
      updateContactOnly: () => this.updateContactOnly(),
      showAssignButton: () => this.showAssignButton(),
      showAcceptButton: () => this.showAcceptButton(),
      showRejectButton: () => this.showRejectButton(),
      showUpdateContactOnlyButton: () => this.showUpdateContactOnlyButton(),
      showMatchToExistingContactButton: () => this.showMatchToExistingContactButton(),
    };

    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      const id = paramMap.get('id');
      if (id) {
        this.id = id;
        this.coreService.fileUploadFormIdentifiers['applicationDocumentPlaceholder'] = this.id;
      }
    });
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  formLoaded($event: any): void {
    this.response = $event as ApplicationDetailCreateUpdateCarerResponse;
  }

  modelChanged(event: any): void {
  }

  filter(event: any): void {
  }

  actionButton_noteListPlaceholder_save_Clicked(event: any): void {
    this.spinnerService.showSpinner();
    this.registerSubscription(
      this.appDataService
        .post(API_ENDPOINTS.note.save, { parentEntityId: this.id, noteContent: event.field.data,addUserDetails:true })
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(data => {
          if (data?.status === SAVE_RESULT_STATUS.success) {
            this.reloadPage(true);
          }
        })
    );
  }

  actionButton_personGrid_datagrid_view_Clicked(event: any): void {
    const navExtras = this.getNavigationExtras();
    this.router.navigate(['/', ROUTE_CONSTANTS.person.prefixDetail, event.event.data.id], navExtras);
  }

  buttonClicked(event: any): void {
  }

  save(event: SaveFormEvent) {
  }

  cancel(event: any) {
    this.navigateBackToHome();
  }

  dialogButton_assignApplicationUserPopup_Clicked(event: any): void {
    this.assignApplicationUser(event as ApplicationUserAssignRequestPopupQuestion);
  }

  dialogButton_rejectApplicationPopup_Clicked(event: any): void {
    this.rejectApplication(event as ApplicationRejectPopupQuestion);
  }

  dialogButton_requestBankDetailsEmailNotSent_Clicked(event: any): void {
    this.reloadPage(true);
  }

  private showAssignButton() {
    return this.response.showAssignButton;
  }

  private showAcceptButton() {
    return this.response.showAcceptButton;
  }

  private showRejectButton() {
    return this.response.showRejectButton;
  }

  private showUpdateContactOnlyButton() {
    return this.response.showUpdateContactOnlyButton;
  }

  private showMatchToExistingContactButton() {
    return this.response.showMatchToExistingContactButton;
  }

  private home(): void {
    this.navigateBackToHome();
  }

  private navigateBackToHome(ignoreUnsavedChanges = false): void {
    const navExtras = this.getNavigationExtras();
    this.navigate(['/', ROUTE_CONSTANTS.careAllowanceApplication.list], ignoreUnsavedChanges, navExtras);
  }

  private assign() {
    const popupCode = POP_UP_CODES.applicationDetailCreateUpdateCarer.assignApplicationUser
    this.activeDialog = popupCode;
    this.dialogService.showDialog(popupCode);
  }

  private accept() {
    let popUpCode: string;
    switch (this.response.applicationTypeId) {
      case REFERENCE_DATA_IDS.applicationType.createCarer:
        popUpCode = POP_UP_CODES.applicationDetailCreateUpdateCarer.acceptCreateApplicationConfirmation;
        break;
      case REFERENCE_DATA_IDS.applicationType.updateCarer:
        popUpCode = POP_UP_CODES.applicationDetailCreateUpdateCarer.acceptUpdateApplicationConfirmation;
        break;
      default:
        console.error("Invalid application type", this.response.applicationTypeId);
        break;
    }
    if (popUpCode) {
      this.showAcceptApplicationConfirmationPopup(popUpCode);
    }
  }

  private showAcceptApplicationConfirmationPopup(popUpCode: string) {
    this.dialogService
      .showConfirm(popUpCode)
      .pipe(take(1))
      .subscribe(data => {
        switch (data as DialogResult) {
          case DialogResult.ACCEPTED: {
            this.acceptApplication();
            break;
          }
        }
      });
  }

  private acceptApplication() {
    this.spinnerService.showSpinner();
    this.registerSubscription(
      this.appDataService
        .postAndFetchData(`${API_ENDPOINTS.applicationDetailCreateUpdateCarer.acceptApplication}/${this.id}`)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(response => {
          if (response?.status === SAVE_RESULT_STATUS.success && !response?.isBankDetailsRequestEmailSent) {
            this.activeDialog = POP_UP_CODES.applicationDetailCreateUpdateCarer.requestBankDetailsEmailNotSent;
            this.dialogService.showDialog(this.activeDialog);
            return;
          }
          this.reloadPage(true);
        }
        )
    );
  }

  private assignApplicationUser(popupQuestion: ApplicationUserAssignRequestPopupQuestion) {
    const request = new ApplicationUserAssignRequest(this.id, popupQuestion.assignedToUserIdPopup);
    this.spinnerService.showSpinner();
    this.registerSubscription(
      this.appDataService
        .post(API_ENDPOINTS.applicationDetailCreateUpdateCarer.assignApplicationUser, request)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(response => {
          if (response?.status === SAVE_RESULT_STATUS.success) {
            this.reloadPage(true);
          }
        }
        )
    );
  }

  private reject() {
    if (this.response.showRejectApplicationConfirmationPopup) {
      this.showRejectApplicationConfirmationPopup();
    }
    else {
      this.showRejectApplicationDialog();
    }
  }

  private matchToExistingContact() {
    this.router.navigate(['/', ROUTE_CONSTANTS.person.list, ROUTE_CONSTANTS.person.updateCreateCarerApplicationPrefix, this.id],);
  }

  private showRejectApplicationConfirmationPopup() {
    this.dialogService
      .showConfirm(POP_UP_CODES.applicationDetailCreateUpdateCarer.rejectApplicationConfirmationPopup)
      .pipe(take(1))
      .subscribe(data => {
        switch (data as DialogResult) {
          case DialogResult.ACCEPTED: {
            this.showRejectApplicationDialog();
            break;
          }
        }
      });
  }

  private showRejectApplicationDialog() {
    const popupCode = POP_UP_CODES.applicationDetailCreateUpdateCarer.rejectApplication
    this.activeDialog = popupCode;
    this.dialogService.showDialog(popupCode);
  }

  private rejectApplication(popupQuestion: ApplicationRejectPopupQuestion) {
    const request = new ApplicationRejectRequest(this.id, popupQuestion.applicationRejectionReasonTypeId, popupQuestion.applicationRejectionComments);
    this.spinnerService.showSpinner();
    this.registerSubscription(
      this.appDataService
        .post(API_ENDPOINTS.applicationDetailCreateUpdateCarer.rejectApplication, request)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(response => {
          if (response?.status === SAVE_RESULT_STATUS.success) {
            this.reloadPage();
          }
        }
        )
    );
  }

  private updateContactOnly() {
    this.showUpdateContactOnlyConfirmationPopup();
  }

  private showUpdateContactOnlyConfirmationPopup() {
    this.dialogService
      .showConfirm(POP_UP_CODES.applicationDetailCreateUpdateCarer.updateContactOnlyConfirmationPopup)
      .pipe(take(1))
      .subscribe(data => {
        switch (data as DialogResult) {
          case DialogResult.ACCEPTED: {
            this.updatePersonWithCarerDetails();
            break;
          }
        }
      });
  }

  private updatePersonWithCarerDetails() {
    this.spinnerService.showSpinner();
    this.registerSubscription(
      this.appDataService
        .postAndFetchData(`${API_ENDPOINTS.applicationDetailCreateUpdateCarer.updatePersonWithCarerDetails}/${this.id}`)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(response => {
          if (response?.status === SAVE_RESULT_STATUS.success) {
            this.navigateBackToHome();
          }
        }
        )
    );
  }

  private getNavigationExtras(): NavigationExtras {
      return {
        state: {
          applicationFilterRequest: history.state.applicationFilterRequest
        }
      };
  }
}
